<template>
  <router-view />
</template>

<script>
export default {
  name: "SettingsMain",
};
</script>